import React, { useCallback, useRef, useEffect } from "react";
import { kidsafeData } from "../../config";

export default function Kidsafe() {
  const scriptRef = useRef();
  const { divId, scriptId, dataProduct, scriptSrc } = kidsafeData.seal;

  useEffect(() => {
    return () => {
      if (scriptRef.current) {
        scriptRef.current.remove();
      }
    };
  }, []);

  const handleScriptLoading = useCallback((node) => {
    let kidsafeScript = document.getElementById(scriptId);
    // ONLY perform if the script doesn't already exist
    // might be causing duplicates/slow downs and rate limits
    if (node && !kidsafeScript) {
      kidsafeScript = document.createElement("script");
      kidsafeScript.id = scriptId;
      kidsafeScript.src = scriptSrc;
      kidsafeScript.dataset.product = dataProduct;
      scriptRef.current = kidsafeScript;
      document.body.append(kidsafeScript);
    }
  }, []);

  return <div className="footer-copyright-kidsafe" id={divId} ref={handleScriptLoading} />;
}
